export type ConsentChoice = { analytics: boolean; marketing: boolean };

type Signal = "granted" | "denied";

export type ConsentSignals = {
  analytics_storage: Signal;
  ad_storage: Signal;
  ad_user_data: Signal;
  ad_personalization: Signal;
};

export const ACCEPT_ALL: ConsentChoice = { analytics: true, marketing: true };
export const REJECT_ALL: ConsentChoice = { analytics: false, marketing: false };

/** Analytics → analytics_storage; Marketing → the three ad signals. */
export function signalsFor(choice: ConsentChoice): ConsentSignals {
  const analytics: Signal = choice.analytics ? "granted" : "denied";
  const marketing: Signal = choice.marketing ? "granted" : "denied";
  return {
    analytics_storage: analytics,
    ad_storage: marketing,
    ad_user_data: marketing,
    ad_personalization: marketing,
  };
}
